export default __webpack_public_path__ + "static/media/poppy-stack3.webp";